import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../core/_requests';
import { showError, showSuccess } from '../../../../_mel/customPartials/helper/Alerts';

export function ValidateEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      showError('No code provided in the URL.');
      return;
    }

    setLoading(true);
    verifyEmail(code).then(response => {
      if (response.data?.result?.canLogin) {
        showSuccess("Email Validated! / E-mail onaylandı!")
        setTimeout(() =>{
            navigate('/auth');
          }, 500);
      } else {
        let message = response.data?.result?.message ?? "Unknown Error occurred! / Bilinmeyen bir hata oluştu!";
        showError(message);
      }
    }).catch(error => {
      let message = error?.response?.data?.error?.message ?? "Unknown Error occurred! / Bilinmeyen bir hata oluştu!";
      showError(message);
    }).finally(() => {
      setLoading(false);
    });
  }, [navigate, searchParams]);

  return (
    <div className='h-100 w-100'>
      {loading ? (
        <>
          <b>Türkçe:Lütfen e-postanızı doğrularken bekleyin... </b> <br />
          <p className="text-muted">Please wait while we confirm your email... </p>
        </>
      ) : (
        <>
          <b>E-posta doğrulamanızın işlenmesini bekliyoruz... </b> <br />
          <p className="text-muted">Waiting to process your email confirmation... </p>
        </>
      )}
    </div>
  );
}
